module.exports = __webpack_public_path__ + "static/media/GT-Walsheim-Pro-Regular.aa35135b.OTF";